import React from 'react';
import { UserRole } from '@grcs/types/UserRole';
import { AdminUserViewPageEnhanced } from '../AdminUser/AdminUserViewPage.enhanced';

export const AdminTeacherPageEnhanced: React.FC = () => {
  return <AdminUserViewPageEnhanced user_role={UserRole.TEACHER} />;
};
